// extracted by mini-css-extract-plugin
module.exports = {"updateActionButton":"EditHeroSection_updateActionButton__1aWH9","deleteActionButton":"EditHeroSection_deleteActionButton__2mw0Y"};